import { Controller } from 'stimulus';
import Rails from '@rails/ujs';

export default class extends Controller {
  static get targets() {
    return ['input', 'parts', 'selected', 'clear', 'box', 'full'];
  }

  initialize() {
    this.timeout = null;
    this.articleField = this.inputTarget;
    this.partIdField = this.element.querySelector('[name="part_id"]');
    if (this.articleField.value) {
      this.clearTarget.style.display = 'block';
    } else {
      this.clearTarget.style.display = 'none';
    }
  }

  clear(event) {
    event.preventDefault();
    this.articleField.value = '';
    this.partIdField.value = '';
    this.partsTarget.style.display = 'none';
    this.clearTarget.style.display = 'none';

    if (this.articleField.dataset.multiple != 'true' && this.partIdField.dataset.input) {
      document.getElementById(this.partIdField.dataset.input).value = '';
    }

    if (this.fullTarget) {
      this.fullTarget.innerHTML = '';
    }
  }

  connect() {
    const that = this;
    document.body.addEventListener('click', () => { that.partsTarget.style.display = 'none'; });

    this.inputTarget.addEventListener('keydown', () => this.searchShipmentParts());
    this.inputTarget.addEventListener('paste', () => setTimeout(this.searchShipmentParts(), 250));
  }

  disconnect() {
    this.inputTarget.removeEventListener('keydown', () => this.searchShipmentParts());
    this.inputTarget.removeEventListener('paste', () => this.searchShipmentParts());
  }

  renderNotFound(article) {
    this.partsTarget.innerHTML = `<div class="dropdown-item">Деталь «${article}» не найдена.</div>`;
    this.partsTarget.style.display = null;
  }

  renderPart(part) {
    return `
      <a class="dropdown-item" data-action="click->office--part--simple-search#selectPart" data-part-id="${part.id}"
       data-article="${part.article}" data-brand-name="${part.brandName}" data-description="${part.name}">
        ${part.name}
      </a>
    `;
  }

  renderParts(parts) {
    const result = [];
    for (const part of parts) {
      result.push(this.renderPart(part));
    }
    this.partsTarget.innerHTML = result.join('');
    this.partsTarget.style.display = null;
  }

  searchShipmentParts() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      const article = this.inputTarget.value.replace(/\s/g, '');
      if (article.length > 2) {
        const that = this;
        Rails.ajax({
          type: 'GET',
          url: `/office/parts/simple_search?q=${article}`,
          success: (data) => {
            if (data.length > 0) {
              that.renderParts(data);
            } else {
              that.renderNotFound(article);
            }
          },
          error: () => {
            alert('Ошибка при попытке найти детали по вашему запросу');
          },
        });
      }
    }, 500);
  }

  selectPart(event) {
    this.articleField.value = event.target.dataset.article;
    this.partIdField.value = event.target.dataset.partId;

    if (this.articleField.dataset.multiple != 'true') {
      this.fullTarget.innerHTML = event.target.dataset.description;
    }

    this.partsTarget.style.display = 'none';
    this.clearTarget.style.display = 'block';

    if (this.articleField.dataset.multiple == 'true') {
      if (this.boxTarget) {
        this.boxTarget.style.display = 'block';
      }

      let part = document.createElement('p');
      part.innerHTML = `<label>
      <input type="checkbox" checked="checked" value="${event.target.dataset.partId}"
      name="part_ids[]" id="part_ids_${event.target.dataset.partId}">
      ${event.target.dataset.brandName} ${event.target.dataset.article}
      </label>`;

      this.selectedTarget.appendChild(part);
    } else {
      if (this.partIdField.dataset.input) {
        document.getElementById(this.partIdField.dataset.input).value = event.target.dataset.partId;
      }
    }


  }
}
